import React from 'react'
import {
  createState,
  useState,
} from '@hookstate/core'
import { authFetch } from '~/services/fetch'
import type { IDispatchRegistrationOthers, IMessageOther, IOthersDTO } from '../interfaces/IDispatchRegistrationOthers'
import { toDomain, toFetch } from '~/mappers/registration-other-mappers'
import useDispatchState from './DispatchState'

export const othersDefaultState = {
  item: null,
  notes: null,
  occurrenceId: null,
}

const defaultRegistrationProps: IDispatchRegistrationOthers = {
  other: othersDefaultState,
}

const registrationOthersDispatchState = createState<IDispatchRegistrationOthers>(defaultRegistrationProps)

export default function useDispatchRegistrationOthersState() {
  const registrationOtherDispatch = useState(registrationOthersDispatchState);
  const { dispatch } = useDispatchState();
  const { occurrence, status, id: dispatchIdState } = dispatch();


  return {
    registrationOtherDispatch: () => registrationOtherDispatch,
    getAssociatedOtherRecord: async (id: string) => {
      const response = await authFetch({
        url: `/associated-other-record/${id}`
      });

      registrationOtherDispatch.other.set(toDomain(response.data))
    },
    getAllAssociatedOtherRecord: async (occurrenceId: number | string | null) => {
      if (occurrenceId) {
        const response = await authFetch({
          url: '/occurrence/associated-other-record/all-from-occurrence',
          data: {
            occurrence_id: occurrenceId
          }
        });

        return response.data.map((otherItem): IOthersDTO => {
          return toDomain(otherItem)
        })
      }
    },
    sendOtherRecord: async (otherRecord: IOthersDTO) => {
      return await authFetch({
        url: '/occurrence/associated-other-record/store',
        data:  toFetch(otherRecord)
      })
    },
    editOtherRecord: async ({id, ...other}: IOthersDTO) => {
      return await authFetch({
        url: `/occurrence/associated-other-record/${id}`,
        method: 'PUT',
        data: toFetch(other)
      })
    },
    deleteOtherRecord: async (id: string) => {
      return await authFetch({
        url: `/occurrence/associated-other-record/${id}`,
        method: 'DELETE'
      })
    },
  }
}